import React from 'react';

import { Text } from 'reaxl';

export default function AtcBranding({ className }) {
    return (
        <Text
            className={className}
            componentClass="div"
            color="subdued-lighter"
            size={200}
        >
            Powered by Autotrader
        </Text>
    );
}
